// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-popup-wrap__title{padding-right:10px;font-size:var(--co857n);font-weight:var(--b8yerr);margin-bottom:24px}.base-popup-wrap__sub-title{font-size:16px;line-height:24px;margin-bottom:8px}.base-popup-wrap__content{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
